<template>
	<sf-data-table
		ref="partTable"
		:pageUnit="pagingInfo.pageUnit"
		:totalSize="pagingInfo.totalSize"
		paging
		:columns="columns"
		:rows="partList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		height="520px"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/PartPopup/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('QWCC000956'), //품번
					prop: 'partNo',
					minWidth: '150px',
					clickEvent: this.scrNameClick,
					sortable: false,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				},
				{
					label: this.getMessage_('QWCC000968'), //기본단위
					prop: 'bascUtm',
					minWidth: '150px',
					sortable: false,
					highlight: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload', currentPageVal, pageUnitVal);
		},
		scrNameClick(row) {
			this.$emit('SendPartData', row);
		}
	}
};
</script>

<style></style>
